export default __webpack_public_path__ + "static/media/folder-large-blue-3x.cfa9f017.png";